/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
import React from 'react';

export default (): JSX.Element => (
  <svg width={370} height={25} xmlns="http://www.w3.org/2000/svg">
    <g fill="#FFF">
      <path d="M0 24.314V5.411A18.765 18.765 0 0013.497 0c7.327 7.225 19.078 7.225 26.405 0 7.329 7.23 19.086 7.23 26.414 0 7.327 7.225 19.078 7.225 26.406 0 7.333 7.218 19.08 7.218 26.413 0a18.705 18.705 0 009.45 5.026v19.288H0z" />

      <path d="M260.585 24.314V5.026A18.705 18.705 0 01251.135 0c-7.333 7.218-19.08 7.218-26.413 0-7.328 7.225-19.079 7.225-26.406 0-7.328 7.23-19.085 7.23-26.414 0-7.327 7.225-19.078 7.225-26.405 0-7.331 7.217-19.075 7.217-26.406 0a18.808 18.808 0 01-8.985 4.932L110 24.314h150.585z" />

      <path d="M370 24.314H242l.106-19.382A18.808 18.808 0 00251.09 0c7.33 7.217 19.075 7.217 26.406 0 7.327 7.225 19.078 7.225 26.405 0 7.329 7.23 19.086 7.23 26.414 0 7.327 7.225 19.078 7.225 26.406 0A18.77 18.77 0 00370 5.413v18.901z" />
    </g>
  </svg>
);
